export const pathes = {
  DEFAULT: '/',
  BASE_PATH: '/taxi-driver',
  HOME: '/home',
  BANK_ACCOUNT_DETAILS: '/bank-account-details',
  PAYMENT_OF_PASSENGERS: '/payment-of-passengers',
  CHECKOUT: '/checkout',
}
